import {
  BooleanInput,
  Create,
  Edit,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

const CategoryFormFields = () => (
  <>
    <TextInput source="name" fullWidth validate={(value) => (!value ? 'Name is required' : undefined)} />
    <TextInput source="slug" fullWidth helperText="Leave blank to auto-generate from name" />
    <ReferenceInput source="parent_id" reference="categories" label="Parent category">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <TextInput source="icon" fullWidth helperText="Optional icon key or URL" />
    <NumberInput source="display_order" label="Display order" defaultValue={0} />
    <BooleanInput source="is_active" label="Active" defaultValue />
  </>
);

export function CategoryEdit() {
  return (
    <Edit>
      <SimpleForm>
        <CategoryFormFields />
      </SimpleForm>
    </Edit>
  );
}

export function CategoryCreate() {
  return (
    <Create redirect="list">
      <SimpleForm defaultValues={{ is_active: true, display_order: 0 }}>
        <CategoryFormFields />
      </SimpleForm>
    </Create>
  );
}
